<ion-grid>
  <app-calibration-evaluation-answer
    *ngFor="let question of questions"
    [question]="question"
    [possibleValues]="possibleValues"
  ></app-calibration-evaluation-answer>
</ion-grid>